module.exports = __webpack_public_path__ + "img/vexento.10ec3817.jpg";